import { HttpClient } from "./HttpClient";
import { HomeAPIClient } from "./modules/home.apiClient";
import { ConsumptionAPIClient } from "./modules/consumption.apiClient";
import { PaymentAPIClient } from "./modules/payment.apiClient";
import { UserAPIClient } from "./modules/user.apiClient";
import { ContentAPIClient } from "./modules/content.apiClient";
import { EventAPIClient } from "./modules/event.apiClient";
import { MessagingAPIClient } from "./modules/messaging.apiClient";
import { SettingAPIClient } from "./modules/settings.apiClient";
import { PartnerAPIClient } from "./modules/partner.api-client";
import { StaticAPIClient } from "./modules/static.apiClient";
import { SearchAPIClient } from "./modules/search.apiClient";
import { SpecialAccessAPIClient } from "./modules/specialAccess.apiClient";
import { ChatAPIClient } from "./modules/chat.apiClient";
import { StripeAPIClient } from "./modules/stripe.apiClient";

export class StageApiSdk {
  public home: HomeAPIClient;
  public consumption: ConsumptionAPIClient;
  public payment: PaymentAPIClient;
  public user: UserAPIClient;
  public content: ContentAPIClient;
  public event: EventAPIClient;
  public messaging: MessagingAPIClient;
  public setting: SettingAPIClient;
  public partner: PartnerAPIClient;
  public static: StaticAPIClient;
  public search: SearchAPIClient;
  public specialAccess: SpecialAccessAPIClient;
  public chat: ChatAPIClient;
  public stripe: StripeAPIClient;

  constructor() {
    const httpClient = new HttpClient();

    this.home = new HomeAPIClient(httpClient);
    this.consumption = new ConsumptionAPIClient(httpClient);
    this.payment = new PaymentAPIClient(httpClient);
    this.user = new UserAPIClient(httpClient);
    this.content = new ContentAPIClient(httpClient);
    this.event = new EventAPIClient(httpClient);
    this.messaging = new MessagingAPIClient(httpClient);
    this.setting = new SettingAPIClient(httpClient);
    this.partner = new PartnerAPIClient(httpClient);
    this.static = new StaticAPIClient(httpClient);
    this.search = new SearchAPIClient(httpClient);
    this.specialAccess = new SpecialAccessAPIClient(httpClient);
    this.chat = new ChatAPIClient(httpClient);
    this.stripe = new StripeAPIClient(httpClient);
  }
}
